export const itemTypePricingTypeCodes = {
  FIXED: 'F',
  WHOLESALE_PLUS_MARKUP: 'W',
  MARKET_BASED_DYNAMIC: 'M',
  COMPONENT_BASED: 'C',
  ATTRIBUTE_BASED: 'A',
  COST_BASED: 'K',
}
